import { useEffect, useState } from "react";
import { GIVEAWAY_DEADLINE } from "@/constants/campaign";

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 41);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, GIVEAWAY_DEADLINE - now);
  return {
    hours: Math.floor(diff / 3.6e6),
    minutes: Math.floor((diff % 3.6e6) / 6e4),
    seconds: Math.floor((diff % 6e4) / 1000),
    ms: Math.floor((diff % 1000) / 10),
    ended: diff === 0,
  };
}
